module.exports = __webpack_public_path__ + "img/plus.6b02786b.svg";